export default __webpack_public_path__ + "c54478409e47f16e2bea0015feba2294.png";